import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=167ee8fe"
import script from "./Header3.vue?vue&type=script&lang=js"
export * from "./Header3.vue?vue&type=script&lang=js"
import style0 from "./Header3.vue?vue&type=style&index=0&id=167ee8fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports